module.exports = __webpack_public_path__ + "img/60x32x96-Kit.7247ae68.png";